const isAbsoluteLink = (href: string) =>
  (href.startsWith('https://') || href.startsWith('http://') || href.startsWith('#') || href.startsWith('mailto:'));

export default isAbsoluteLink;